import { MENU_ITEM } from 'constants/menu/formTypes';

export const getCartItemById = (cart, cartItemId) => {
  return cart.items.find(item => item.id === cartItemId);
};

export const getInventoryIsDepletedWithCurrentQuantity = (
  inventoryLessCart,
  formState,
  formType,
  cartItem
) => {
  if (inventoryLessCart === null) {
    return false;
  }
  return formType === MENU_ITEM
    ? inventoryLessCart - formState.quantity === 0
    : inventoryLessCart - (formState.quantity - cartItem.quantity) === 0;
};

export const doesPreviewedQuantityExceedsInventory = (
  inventory,
  inventoryLessCart,
  formType,
  requestedQuantity,
  cartQuantity
) => {
  if (inventoryLessCart === null) {
    return false;
  }
  if (formType === MENU_ITEM) {
    return inventoryLessCart - requestedQuantity < 0;
  } else {
    const newRequestedInventory = requestedQuantity - cartQuantity;
    return inventoryLessCart - newRequestedInventory > inventory;
  }
};
